<footer class="position-relative z-1">
  <div class="container">
    <div class="row g-3">
      <div class="col-xl-3 col-lg-6">
        <div>
          <img
            class="rounded-3 overflow-hidden"
            [src]="logo"
            width="180px"
            height="80px"
            [alt]="title"
            [title]="title"
          />
          <p class="my-3">
            We take care of every detail you can travel with confidence ease.
          </p>

          <div>
            <i class="fa fa-headphones-alt textSecondColor me-2"></i>
            <span>Need help? Call us</span>
          </div>
          <a
            href="tel:{{ phoneNumber }}"
            class="text-black fw-bold fs-4 text-decoration-none"
            >{{ phoneNumber }}</a
          >
        </div>
      </div>
      <div class="col-xl-2 col-lg-3">
        <div class="text-capitalize">
          <h5 class="fw-bold text-black mb-3">Quick Links</h5>
          <ul class="list-unstyled bg-dange ms-1">
            <li
              [routerLink]="['/destination']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              Destinations
            </li>
            <li
              [routerLink]="['/blog']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              Tour blogs
            </li>
            <li
              [routerLink]="['/about']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              about us
            </li>
            <li
              [routerLink]="['/makeTrip']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              How It Work
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3">
        <div class="text-capitalize">
          <h5 class="fw-bold text-black mb-3">Popular Services</h5>
          <ul class="list-unstyled bg-dange ms-1">
            <li
              [routerLink]="['/contact']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              contact us
            </li>
            <li
              [routerLink]="['']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              privacy & policy
            </li>
            <li
              [routerLink]="['']"
              routerLinkActive="router-link-active"
              class="d-flex align-items-center mb-2 cPointer"
            >
              <i class="fa fa-caret-right me-2 textMainColor"></i>
              terms & conditions
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6">
        <div class="text-capitalize ps-3">
          <h5 class="fw-bold text-black mb-3">Newsletter</h5>
          <p class="">Get every travel news update</p>
          <div>
            <input
              type="email"
              class="form-control"
              placeholder="Email Address"
            />
            <button
              type="submit"
              class="mainBtn Btn flexCenter gap-2 mx-2 my-3"
            >
              subscribe
              <i
                class="fa fa-arrow-right fa-rotate-by bgPrimaryWhiteColor rounded-circle overflow-hidden"
              ></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3">
        <div class="text-capitalize">
          <h5 class="fw-bold text-black mb-3">Follow Us</h5>
          <app-social></app-social>
        </div>
      </div>
    </div>

    <!-- <div class="big-text mt-5 text-center">
      <h2 class="mb-0">Travel Adventure</h2>
    </div> -->
  </div>

  <!-- <div class="svg-shape-wrapper">
    <svg
      class="position-absolute bottom-0 start-0 w-100 h-100"
      viewBox="0 0 2 1"
      preserveAspectRatio="none"
    >
      <defs>
        <path id="w" d=" m0 1v-.5 q.5.5 1 0 t1 0 1 0 1 0 v.5z"></path>
      </defs>
      <g>
        <use href="#w" fill="rgba(242, 151, 39, 0.09)"></use>
        <use href="#w" fill="rgba(242, 151, 39, 0.05)"></use>
      </g>
    </svg>
  </div> -->
</footer>
